import Books from '../pages/Books.vue'

export default [
  {
    path: '/',
    name: 'Books',
    component: Books,
    meta: { title: 'Spaces - hello ivy' }
  },
  {
    path: '/:domain/share/:shareId',
    name: 'Share',
    component: () => import('@/pages/Share.vue')
  },
  {
    path: '/social-auth/success',
    name: 'SocialAuthSuccess'
  },
  {
    path: '/social-auth/failed',
    name: 'SocialAuthFailed',
    component: () => import('@/pages/auth/FailedLogin.vue'),
    meta: { title: 'Auth Failed - hello ivy' }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: () => import('@/pages/payment/Success.vue'),
    meta: { title: 'Payment Success - hello ivy' }
  },
  {
    path: '/payment/failed',
    name: 'PaymentFailed',
    component: () => import('@/pages/payment/Failed.vue'),
    meta: { title: 'Payment Failed - hello ivy' }
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: () => import('@/pages/auth/SignUpMain.vue'),
    meta: { title: 'Sign up - hello ivy' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/auth/Login.vue'),
    meta: { title: 'Login - hello ivy' }
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('@/pages/auth/Unauthorized.vue'),
    meta: { title: 'Unauthorized - hello ivy' }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/pages/auth/ResetPassword.vue'),
    meta: { title: 'Reset Password - hello ivy' }
  },
  {
    path: '/password-recover',
    name: 'PasswordRecover',
    component: () => import('@/pages/auth/PasswordRecover.vue'),
    meta: { title: 'Password Recover - hello ivy' }
  },
  {
    path: '/space/:id',
    name: 'Book',
    component: () => import('@/pages/Book.vue')
  },
  {
    path: '/week-planner',
    name: 'WeekPlanner',
    component: () => import('@/pages/WeekPlanner.vue'),
    meta: { title: 'Week Planner - hello ivy' }
  },
  {
    path: '/task-board',
    name: 'TaskBoard',
    component: () => import('@/pages/TaskBoard.vue'),
    meta: { title: 'Task board - hello ivy' }
  },
  {
    path: '/ui-kit',
    name: 'UIKit',
    component: () => import('@/pages/UiKit.vue'),
    meta: { title: 'UIKit - hello ivy' }
  },
  {
    path: '/inbox',
    name: 'Inbox',
    component: () => import('@/pages/Inbox.vue'),
    meta: { title: 'Inbox - hello ivy' }
  },
  {
    path: '/:team',
    name: 'TeamBooks',
    component: () => import('@/pages/Books.vue'),
    meta: { title: 'Spaces - hello ivy' }
  },
  {
    path: '/:team/space/:id',
    name: 'TeamBook',
    component: () => import('@/pages/Book.vue')
  },
  {
    path: '/:team/headquarters',
    name: 'Headquarters',
    component: () => import('@/pages/Headquarters.vue'),
    meta: { title: 'Headquarters - hello ivy' }
  },
  {
    path: '/:team/task-board',
    name: 'TaskBoardTeam',
    component: () => import('@/pages/TaskBoard.vue'),
    meta: { title: 'Task board - hello ivy' }
  },
  {
    path: '/:team/week-planner',
    name: 'WeekPlannerTeam',
    component: () => import('@/pages/WeekPlanner.vue'),
    meta: { title: 'Week Planner - hello ivy' }
  },
  {
    path: '/:pathMatch(.*)',
    redirect: { name: 'Books', query: {} }
  }
]
